var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2159 21H6.78462C4.94959 21 3.46289 19.5123 3.46289 17.6783V10.5045C3.46289 9.6133 3.86376 8.76973 4.55457 8.20638L10.1287 3.66551C11.2185 2.77816 12.782 2.77816 13.8718 3.66551L19.4459 8.20638C20.1367 8.76973 20.5376 9.6133 20.5376 10.5045V17.6783C20.5376 19.5123 19.0509 21 17.2159 21Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNavIcon);
export default __webpack_public_path__ + "static/media/home_nav_icon.3bed2f35ff181100feb65f549d3712f4.svg";
export { ForwardRef as ReactComponent };